import React from 'react';
import styled from 'styled-components';
import { DefaultPalette, Slider, Stack, IStackStyles, IStackTokens } from '@fluentui/react';
import Objective from './dashboard/objective';
import Factor from './dashboard/factor';
import Age from './dashboard/age';
import ComeBack from './dashboard/comeback';
import Suggest from './dashboard/suggest';
import Hotel from './dashboard/hotel';
import BirthPlace from './dashboard/birthplace';
import Gender from './dashboard/gender';
import Rate from './dashboard/rate';
import Overview from './dashboard/overview';


const itemStyles = {
    alignItems: 'center',
    background: '#f2f2f2',
    // color: DefaultPalette.white,
    display: 'flex',
    height: '300px',
    width: '400px',
    justifyContent: 'center',
};

const stack1Styles = {
    root: {
        width: `400px`
    },
};

const stack2Styles = {
    root: {
        width: `600px`
    },
};

const stackStyles = {
    root: {
        width: `100%`
    },
};

const stackWrapperStyles = {
    backgroundColor: `#000000`,
    height: `100vh`
};

const Wrapper = styled.div`
    background-color: #fafafa;
    min-height: 100%;
    padding: 20px;
`;

class Dashboard extends React.Component {

    render() {
        // Tokens definition
        const sectionStackTokens = { childrenGap: 10 };
        const wrapStackTokens = { childrenGap: 10 };

        return (
            <Wrapper>
                <Stack horizontal tokens={sectionStackTokens}>
                    <Stack wrap styles={stack1Styles} tokens={wrapStackTokens}>
                        <Overview />
                        <Gender />
                        <Age />
                        <BirthPlace />
                        <Hotel />
                    </Stack>
                    <Stack wrap styles={stack2Styles} tokens={wrapStackTokens}>
                        <Objective />
                        <Factor />
                        <ComeBack />
                        <Suggest />
                    </Stack>
                    <Stack wrap styles={stackStyles} tokens={wrapStackTokens}>
                    <Rate />

                    </Stack>
                </Stack>
            </Wrapper>
        );
    }
}

export default Dashboard;